import useOcapiSite from './useOcapiSite'
import {MAX_ENGRAVING_CHARACTERS} from '../constants'

/**
 * Maximum number of characters allowed for a product engraving.
 *
 * Uses the `engravingMaxChars` site pref if it is defined and a positive number,
 * otherwise falls back to {@link MAX_ENGRAVING_CHARACTERS}.
 *
 * @return {number}
 */
const useEngravingMaxChars = () => {
    const {engravingMaxChars} = useOcapiSite().customPreferences
    const maxChars = Number(engravingMaxChars)

    return maxChars > 0 ? maxChars : MAX_ENGRAVING_CHARACTERS
}

export default useEngravingMaxChars
